<ng-container *transloco="let t">
  <div (click)="onClicked()" [ngStyle]="{'color': color}" title="{{t('Select color')}}" class="mat-elevation-z1" style="box-shadow: none !important; height: 20px !important;">
    <mat-icon class="material-symbols-outlined" style="font-size: 20px; height: unset !important; width: unset !important;">palette</mat-icon>
  </div>
</ng-container>
